import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AustinPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What types of apps does TekRevol develop in Austin?",
    answer: `<p>TekRevol develops a wide range of apps for different industries including healthcare, retail, entertainment, education, and more. They specialize in developing custom mobile apps for both iOS and Android platforms.</p>`,
  },
  {
    question:
      "What is the estimated cost and timeline for app development in Austin?",
    answer: ` <p>The cost and timeline for app development with TekRevol depend on various factors such as app complexity, features, platform, and more. They provide a detailed proposal with a breakdown of the cost and timeline after evaluating the project requirements.</p>`,
  },
  {
    question:
      "What makes TekRevol stand out from other app development companies in Austin?",
    answer: `<p>TekRevol’s team of experienced developers, designers, and project managers work collaboratively with the clients to provide tailored solutions that meet their unique business needs. They also offer ongoing support and maintenance services to ensure the app runs smoothly.</p>`,
  },
  {
    question:
      "Can TekRevol provide ongoing maintenance and updates for the app after it is developed?",
    answer: `<p>Yes, TekRevol offers ongoing support and maintenance services for the app after it is developed. They also provide updates and enhancements to the app as per the client's requirements and feedback to ensure its optimal performance and user engagement.</p>`,
  },
  {
    question: "How to hire an app development company in Austin?",
    answer: ` <p>You can shortlist, and hire the most professional app development company in Austin, only if you follow these quick steps:</p>  
        <ul>
        <li>The first and most important thing is to have a clear idea in your mind, what you’re looking for, in order to hunt for the ideal candidate.</li>
        <li>Secondly, ask them to share their past work and portfolio so you can have an idea what they’re going to produce as an end result.</li>
        <li>Set up a first kick-off meeting with them once you’ve gone through all the portfolio, past client feedback, and everything essential necessary to finalize an app development company Austin.</li>
    </ul>`,
  },
  {
    question: "Does TekRevol offer ongoing app maintenance and updates?",
    answer: `<p>Yes, we offer post-launch support and maintenance services. Our team takes care of client queries and also provides updates and enhancements to the app as per the client's requirements and feedback to ensure its optimal performance and user engagement.</p>`,
  },
  {
    question: "How much does it cost to develop a mobile app in Austin?",
    answer: `<p>The cost to develop a mobile app in Austin is solely based on the chosen framework, operating system, and desired features and functionalities. However, if you want to determine the average cost of your mobile app development, you can use our calculator.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Austin Mobile App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{AustinPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
